import { render, staticRenderFns } from "./ArticleImportObservations.vue?vue&type=template&id=2d458b5e&"
import script from "./ArticleImportObservations.vue?vue&type=script&lang=js&"
export * from "./ArticleImportObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports